import MenuPathModel from "models/MenuPathModel";
import { lazy } from "react";
import CercaPreventivo from "views/ricerca-preventivi/CercaPreventivo";
import CercaSimulazione from "views/ricerca-simulazione/CercaSimulazione";
import RouteEnum from "./RouteEnum";

const AccessoPage = lazy(() => import("views/accesso-page/AccessoPage"));
const Dashboard = lazy(() => import("views/dashboard/Dashboard"));
const CQS = lazy(() => import("views/cqs/CQS"));
const DLG = lazy(() => import("views/dlg/DLG"));
const CQP = lazy(() => import("views/cqp/CQP"));
const Accessibilita = lazy(() => import("views/accessibilita/Accessibilta"));
const Cookies = lazy(() => import("views/cookies/Cookies"));
const NoteLegali = lazy(() => import("views/note-legali/NoteLegali"));
const PrivacyPolicy = lazy(() => import("views/privacy-policy/PrivacyPolicy"));
const Agenda = lazy(() => import("views/agenda/Agenda"));
const Notifiche = lazy(() => import("../views/components/notifiche/Notifiche"));
const Note = lazy(() => import("../views/components/note/Note"));
const SearchSimulazione = lazy(() => import("../views/components/search/SearchSimulazione"));
const SearchPreventivo = lazy(() => import("../views/components/search/SearchPreventivo"));
const LandingPage = lazy(() => import("../views/components/risultati/Risultati"));
const RisultatiPreventivi = lazy(() => import("../views/components/risultati/RisultatiPreventivi"));
const RisultatiSimulazione = lazy(() => import("../views/components/risultati/RisultatiSimulazione"));
const CQCRM = lazy(() => import("../views/components/cqcrm/CQCRM"));

export const RouteMapping = [
    new MenuPathModel({
        path: RouteEnum.ACCESSO,
        component: AccessoPage,
        exact: true,
    }),
    new MenuPathModel({
        path: RouteEnum.HOME,
        component: Dashboard,
        exact: true,
    }),
    new MenuPathModel({
        path: RouteEnum.CQS,
        component: CQS,
        exact: true,
    }),
    new MenuPathModel({
        path: RouteEnum.DLG,
        component: DLG,
        exact: true,
    }),
    new MenuPathModel({
        path: RouteEnum.CQP,
        component: CQP,
        exact: true,
    }),
    new MenuPathModel({
        path: RouteEnum.ACCESSIBILITA,
        component: Accessibilita,
        exact: true,
    }),
    new MenuPathModel({
        path: RouteEnum.COOKIES,
        component: Cookies,
        exact: true,
    }),
    new MenuPathModel({
        path: RouteEnum.NOTE_LEGALI,
        component: NoteLegali,
        exact: true,
    }),
    new MenuPathModel({
        path: RouteEnum.PRIVACY_POLICY,
        component: PrivacyPolicy,
        exact: true,
    }),
    new MenuPathModel({
        path: RouteEnum.SIMULAZIONI,
        component: CercaSimulazione,
        exact: true,
    }),
    new MenuPathModel({
        path: RouteEnum.PREVENTIVI,
        component: CercaPreventivo,
        exact: true,
    }),
    new MenuPathModel({
        path: RouteEnum.NUOVO_APPUNTAMENTO,
        component: Agenda,
        exact: true,
    }),
    new MenuPathModel({
        path: RouteEnum.NOTIFICHE,
        component: Notifiche,
        exact: true,
    }),
    new MenuPathModel({
        path: RouteEnum.NOTE,
        component: Note,
        exact: true,
    }),
    new MenuPathModel({
        path: RouteEnum.SEARCH_SIMULAZIONE + "/:id?",
        component: SearchSimulazione,
        exact: true,
    }),
    new MenuPathModel({
        path: RouteEnum.SEARCH_PREVENTIVO + "/:id?",
        component: SearchPreventivo,
        exact: true,
    }),
    new MenuPathModel({
        path: RouteEnum.RISULTATI,
        component: LandingPage,
        exact: true,
    }),
    new MenuPathModel({
        path: RouteEnum.RISULTATI_SIMULAZIONE,
        component: RisultatiSimulazione,
        exact: true,
    }),
    new MenuPathModel({
        path: RouteEnum.RISULTATI_PREVENTIVI,
        component: RisultatiPreventivi,
        exact: true,
    }),
    new MenuPathModel({
        path: RouteEnum.CQ_CRM,
        component: CQCRM,
        exact: true,
    }),
];
